import tmsApi from '../api/tmsApi';
import helper from './helper';

const { createInputParam } = helper;

export default {
  namespaced: true,
  state: {
    dataState: {
      employee: 'LOADING',
      employeeInfo: 'LOADING',
    },
    employees: [],
    detailData: null,
    detailDataId: null,
    dataLoaded: false,
    activites: [],
    count_info: {
      all: 0,
      default: 0,
      loader: 0,
      driver: 0,
      operator: 0,
    },
    query: {
      search: '',
      company_id: null,
      page: {
        number: 1,
        count: 10,
      },
      sort: {
        by: 'NAME',
        direction: 'ASC',
      },
      type: null,
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.employees.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.employees.push(data);
    },
    REPLACE_DATA(state, employees) {
      state.employees.splice(0, state.employees.length, ...employees);
    },
    ADD_ACTIVITIES(state, data) {
      state.activites = data;
    },
    CLEAR_QUERY({ query }) {
      query.search = '';
      query.company_id = null;
      query.page.number = 1;
      query.page.count = 10;
      query.sort.by = 'NAME';
      query.sort.direction = 'ASC';
    },
    SET_COMPANY_ID(state, id) {
      state.query.page.number = 1;
      state.query.page.count = 10;
      state.query.company_id = id;
    },
    SET_QUERY_SEARCH(state, search) {
      state.query.page.number = 1;
      state.query.page.count = 10;
      state.query.search = search;
    },
    SET_QUERY_PAGE(state, number) {
      state.query.page.number = number;
    },
    SET_QUERY_COUNT(state, count) {
      state.query.page.count = count;
    },
    SET_QUERY_SORT(state, sort) {
      const rSort = sort || 'NAME.ASC';
      const [by, direction] = rSort.split('.');
      state.query.sort.direction = direction;
      state.query.sort.by = by;
    },
    SET_QUERY_TYPE(state, type) {
      state.query.type = type;
    },
    SET_COUNT_INFO(state, info) {
      state.count_info.all = 0;
      state.count_info.default = 0;
      state.count_info.loader = 0;
      state.count_info.driver = 0;
      state.count_info.operator = 0;
      info.forEach((c) => {
        state.count_info.all += c.count;
        if (c.type === 'DEFAULT') {
          state.count_info.default += c.count;
        } else if (c.type === 'LOADER') {
          state.count_info.loader += c.count;
        } else if (c.type === 'DRIVER') {
          state.count_info.driver += c.count;
        } else if (c.type === 'OPERATOR') {
          state.count_info.operator += c.count;
        }
      }, this);
    },
    SET_DETAIL_ID(state, id) {
      state.detailDataId = id;
    },
    SET_DETAIL_DATA(state, data) {
      state.detailData = data;
    },
    DELETE_DETAIL_DATA(state, id) {
      const index = state.employees.findIndex(employee => employee.id === id);
      state.employees.splice(index, 1);
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
    SET_DATA_LOADED(state) {
      state.dataLoaded = true;
    },
    SET_DATA_NOT_LOADED(state) {
      state.dataLoaded = false;
    },
    SET_DATA_EMPLOYEE({ dataState }, state) {
      dataState.employee = state;
    },
    SET_STATE_EMPLOYEE_INFO({ dataState }, state) {
      dataState.employeeInfo = state;
    },
  },
  getters: {
    employees(state) {
      return state.employees;
    },
    count_all(state) {
      return state.count_info.all;
    },
    count_default(state) {
      return state.count_info.default;
    },
    count_loader(state) {
      return state.count_info.loader;
    },
    count_driver(state) {
      return state.count_info.driver;
    },
    count_operator(state) {
      return state.count_info.operator;
    },
    query_count(state) {
      return state.query.page.count;
    },
    query_page(state) {
      return state.query.page.number;
    },
    get_detail_data(state) {
      return state.detailData || {};
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },
    get_activity(state) {
      return state.activites;
    },
    loadEmployee(state) {
      return state.dataState.employee;
    },
    employeeInfoState(state) {
      return state.dataState.employeeInfo;
    },
  },
  actions: {
    LOAD_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { number, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const offset = (number - 1) * count;
      const limit = count;
      const companyId = createInputParam(state.query, 'company_id', false);
      const type = createInputParam(state.query, 'type', false);
      let searchQuery = '';
      if (typeof state.query.search === 'string' && state.query.search.trim().length) {
        const q = state.query.search.trim();
        searchQuery = `query: "${q}"`;
      }
      const query = `
        {
          employees(
            offset: ${offset},
            limit: ${limit},
            ${searchQuery}
            sort: {
                by: ${by},
                direction: ${direction}
            },
            ${type}
            ${companyId}
          ) {
              id
              name
              number
              user {
                id
                username
                full_name
                email
                address {
                  country
                  state
                  city
                  address1
                  address2
                  zip_code
                }
              }
              company {
                id
                name
                active
                parent {
                  id
                }
              }
              dob
              type
              created_at
              metadata
              vehicle {
                id
              }
          }
        }
      `;
      // commit('SET_DATA_NOT_LOADED');
      commit('SET_DATA_EMPLOYEE', 'LOADING');
      return api(query, 'employees').then(({ data }) => {
        const { employees } = data;
        commit('REPLACE_DATA', employees);
        // commit('SET_DATA_LOADED');
        commit('SET_DATA_EMPLOYEE', 'LOADED');
      }).catch(() => {
        commit('SET_DATA_EMPLOYEE', 'ERROR');
      });
    },
    LOAD_INFO({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const companyId = createInputParam(state.query, 'company_id', false);
      const query = `
        {
          employee_info(
           query: "${state.query.search}"
           ${companyId}
          ) {
            count
            type
          }
        }
      `;
      commit('SET_STATE_EMPLOYEE_INFO', 'LOADING');
      return api(query, 'employee_info').then(({ data }) => {
        const { employee_info } = data;
        commit('SET_COUNT_INFO', employee_info);
        commit('SET_STATE_EMPLOYEE_INFO', 'LOADED');
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_INFO');
        commit('SET_STATE_EMPLOYEE_INFO', 'ERROR');
      });
    },
    FIND_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { number, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const offset = (number - 1) * count;
      const limit = count;
      const companyId = createInputParam(state.query, 'company_id', false);
      const type = createInputParam(state.query, 'type', false);
      const query = `
        {
          employees: find_employees(
            query: "${state.query.search}",
            offset: ${offset},
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${type}
            ${companyId}
          ) {
            id
            name
            number
            user {
              id
              username
              full_name
              email
              address {
                country
                state
                city
                address1
                address2
                zip_code
              }
            }
            company {
              id
              name
              active
            }
            dob
            type
            created_at
          }
        }
      `;
      commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      return api(query, 'find_employees').then(({ data }) => {
        const { employees } = data;
        employees.forEach((employee) => {
          commit('ADD_DATA_ON_LIST', employee);
        }, this);
      }).then(() => {
        setTimeout(() => commit('SET_DATA_LOADED'), 1e3);
      }).catch(() => {
        commit('ADD_ERROR', 'FIND_DATA');
      });
    },
    LOAD_DETAIL_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
      {
        employee(id: ${state.detailDataId}) {
          id
          name
          number
          dob
          user {
            id
            username
            full_name
            email
            address {
              country
              state
              city
              address1
              address2
              zip_code
            }
            created_at
          }
          type
          company {
            id
            name
            type
          }
          vehicle {
            id
          }
          metadata
          created_at
        }
      }
      `;
      return api(query, 'employee').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.employee);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DETAIL_DATA');
      });
    },
    UPDATE_DATA({ state, commit, rootState }, payloads) {
      const { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);
      const {
        company,
        userId,
        fmType,
        name,
        number,
        type,
      } = payloads;
      const updateMetadata = {
        fatigue_management_type: fmType,
      };

      const variables = {
        id: detailDataId,
        input: {
          name,
          type,
          number,
          company_id: company.id,
          user_id: userId,
          update_meta: updateMetadata,
        },
      };

      const query = `
        mutation EmployeeUpdate($id: ID!, $input: EmployeeUpdate) {
          employee: update_employee(id: $id, input: $input) {
            id
            name
            number
            dob
            user {
              id
              username
              full_name
              email
              address {
                country
                state
                city
                address1
                address2
                zip_code
              }
              created_at
            }
            type
            company {
              id
              name
              type
            }
            metadata
            created_at
          }
        }
      `;

      return api({
        query,
        variables,
      }, 'update_employee').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.employee);
        return data.employee;
      }).catch(() => {
        commit('ADD_ERROR', 'UPDATE_DATA');
      });
    },
    UPDATE_METADATA({ state, commit, rootState }, payloads) {
      const { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);
      const {
        userId,
        fmType,
        name,
        number,
        type,
      } = payloads;
      const updateMetadata = {
        fatigue_management_type: fmType,
      };

      const adtData = payloads.metadata;

      const variables = {
        id: detailDataId,
        input: {
          name,
          type,
          number,
          user_id: userId,
          update_meta: updateMetadata,
          metadata: adtData,
        },
      };

      const query = `
        mutation EmployeeUpdate($id: ID!, $input: EmployeeUpdate) {
          employee: update_employee(id: $id, input: $input) {
            id
            name
            number
            dob
            user {
              id
              username
              full_name
              email
              address {
                country
                state
                city
                address1
                address2
                zip_code
              }
              created_at
            }
            type
            company {
              id
              name
              type
            }
            metadata
            created_at
          }
        }
      `;

      return api({
        query,
        variables,
      }, 'update_employee').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.employee);
      }).catch(() => {
        commit('ADD_ERROR', 'UPDATE_DATA');
      });
    },
    CREATE_DATA({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token);
      const {
        userId,
        company,
        fmType,
        type,
        name,
        number,
      } = payloads;

      const variables = {
        input: {
          name,
          type,
          number,
          company_id: company.id,
          user_id: userId,
          metadata: {
            fatigue_management_type: fmType,
          },
        },
      };
      const query = `
        mutation CreateUpdateEmployee($input: EmployeeInput) {
          employee: create_employee(input: $input) {
            id
            name
            number
            dob
            user {
              id
              username
              full_name
              email
              address {
                country
                state
                city
                address1
                address2
                zip_code
              }
              created_at
            }
            type
            company {
              id
              name
              type
            }
            metadata
            created_at
          }
        }`;

      return api({
        query,
        variables,
      }, 'create_employee').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.employee);
        return data.employee;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_DATA');
      });
    },
    DELETE_DATA({ state, commit, rootState }, employeeId) {
      const id = !employeeId ? state.detailDataId : employeeId;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        deleted: delete_employee(id: ${id})
      }`;

      return api(mutation, 'delete_employee').then(({ data }) => {
        const deleteOk = data.deleted;
        if (deleteOk) commit('DELETE_DETAIL_DATA', id);
        return deleteOk;
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_DATA');
      });
    },
    CREATE_EMPLOYEE_USER({ state, commit, rootState }, userId) {
      const { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        employee: create_employee_user(
          employee_id: ${detailDataId},
          user_id: ${userId},
        ) {
          id
          name
          number
          dob
          user {
            id
            username
            full_name
            email
            address {
              country
              state
              city
              address1
              address2
              zip_code
            }
            created_at
          }
          type
          company {
            id
            name
            type
          }
          metadata
          created_at
        }
      }`;

      return api(mutation, 'create_employee_user').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.employee);
        return data.employee;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_EMPLOYEE_USER');
      });
    },
    DELETE_EMPLOYEE_USER({ state, rootState, commit }) {
      const { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        deleted: delete_employee_user(id: ${detailDataId})
      }`;

      return api(mutation, 'delete_employee_user').then(({ data }) => {
        const { deleted } = data;
        return deleted;
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_EMPLOYEE_USER');
      });
    },
    LOAD_EMPLOYEE_ACTIVITY({ rootState, commit }, payloads) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { employee_id: employeeId } = payloads;
      const query = `{
        find_work_histories(employee_id: ${employeeId}) {
          id
          status
          metadata
          created_at
        }
      }
      `;

      return api(query, 'employee_activity').then(({ data }) => {
        const { find_work_histories: activities } = data;
        commit('ADD_ACTIVITIES', activities);
      }).catch(() => {
        commit('ADD_ERROR', 'ADD_ACTIVITIES');
      });
    },
    UPDATE_APP_SELECTION({ commit, rootState }, payloads) {
      const { employeeId: id, metadata } = payloads;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const variables = {
        id,
        input: {
          metadata,
        },
      };

      const query = `
        mutation EmployeeUpdate($id: ID!, $input: EmployeeUpdate) {
          employee: update_employee(id: $id, input: $input) {
            metadata
          }
        }
      `;

      return api({
        query,
        variables,
      }, 'update_app_selection').then(({ data }) => data).catch(() => {
        commit('ADD_ERROR', 'UPDATE_APP_SELECTION');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/employees.js